{
  "(optional)": "(valikuline)",
  "(required)": "(nõutav)"
}
